<template>
  <Form
    :action-type="actionType"
    :subtitle="subtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :form-body="form"
    :starting-stock-balance="form.balance"
    :show-preloader="isLoadingNow"
    :removal-callback="remove"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="top-panel-buttons">
      <DropdownMenu button-icon="key" title="Связи">
        <section
          v-for="(value, key, index) in foreignKeyLabels"
          :key="index"
          class="option"
        >
          <label>{{ value }}</label>
          <ForeignKeyInput
            :value="form[key]"
            :disabled="actionType === 'read'"
            :record-link="getRecordLink(key)"
            @on-trash-click="form[key] = ''"
            @on-plus-click="openedModals[key] = true"
          />
        </section>
      </DropdownMenu>
    </template>
    <template slot="fields">
      <div v-for="(value, key) in modalLabels" :key="value">
        <EntityReferencesModal
          v-if="openedModals[key]"
          :title="value"
          :table-fields="getModalFields(key)"
          :link-slug="getLinkSlug(key)"
          :allow-only-one-choise="allowedOneChoiceInModal(value)"
          :preparing-data="key === 'parent' ? [form] : form[key]"
          :additional-filters="getAdditionalFilters(key)"
          :without-search-form="!!(key === 'sizes_data')"
          :without-table-links="!!(key === 'sizes_data')"
          not-only-ids
          @choose="(values) => updateListField(key, values)"
          @close="openedModals[key] = false"
        />
      </div>
      <Tabs class="form__tabs_product" :header-inline-styles="tabsHeaderStyles">
        <Tab title="Продукт">
          <div class="row">
            <div class="col-lg-12">
              <div
                v-for="(value, key, index) in mainLabels"
                :key="index"
                class="col-lg-6 form-group"
              >
                <fieldset>
                  <label>
                    {{ value }}
                    <span
                      v-if="isRequiredField(validationSchema[key])"
                      class="field__label_required"
                      >*</span
                    >
                  </label>
                  <select
                    v-if="value === 'Пол'"
                    class="form-control"
                    v-model="form.gender"
                    :disabled="actionType === 'read'"
                    @change="form.sizes_data = []"
                  >
                    <option
                      v-for="value in selectValues"
                      :key="value"
                      :value="value"
                    >
                      {{ value }}
                    </option>
                  </select>
                  <input
                    v-else
                    class="form-control"
                    :name="key"
                    :maxlength="maxLength[key]"
                    placeholder="Отсутствует"
                    :disabled="actionType === 'read'"
                    v-model.trim="form[key]"
                  />
                </fieldset>
              </div>
            </div>
            <div class="col-lg-8 form-group">
              <div class="col-lg-5">
                <ReferencesList
                  :label="`Размеры (${form.gender})`"
                  :notice-field="form.gender === 'унисекс' && 'gender'"
                  slug="sizes"
                  :list="form.sizes_data"
                  :item-description-fields="['international_version', 'russian_version']"
                  :buttons-are-visible="actionType !== 'read'"
                  @on-plus-click="openedModals.sizes_data = true"
                  @on-delete="(values) => (form.sizes_data = values)"
                  is-required
                  without-links
                />
              </div>
            </div>
            <div class="col-lg-12">
              <div class="col-lg-5">
                <label class="control-label">
                  Изображение
                  <span v-if="actionType !== 'read'" class="field__label_required">
                    *
                  </span>
                </label>
                <ImageInput
                  :preview-image="previewImage"
                  :only-preview-image="actionType === 'read'"
                  @on-select-file="setImage"
                  @on-delete="deleteImage"
                />
              </div>
            </div>
          </div>
        </Tab>
        <Tab title="Списки расходников">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-12">
                  <div
                    v-for="(value, key, index) in materialListLabels"
                    :key="index"
                    class="col-lg-7 form-group"
                  >
                    <ReferencesList
                      :label="value"
                      :slug="getLinkSlug(key)"
                      :list="form[key]"
                      :buttons-are-visible="actionType !== 'read'"
                      @on-plus-click="openedModals[key] = true"
                      @on-delete="(values) => (form[key] = values)"
                      with-counts
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Tab>
        <Tab title="Характеристики">
          <Sublist
            v-for="(labels, index) in [
              mainCharacterLabels,
              additionalCharacterLabels,
            ]"
            :key="index"
            :visibility-init-state="true"
            :subtitle="getSublistSubtitle(labels)"
          >
            <template slot="fields">
              <div class="row">
              <div class="col-lg-12">
                <div
                  v-for="(value, key, index) in labels"
                  :key="index"
                  class="col-lg-6 form-group"
                >
                  <fieldset>
                    <label>
                      {{ value }}
                      <span
                        v-if="isRequiredField(validationSchema[key])"
                        class="field__label_required"
                        >*</span
                      >
                    </label>
                    <textarea
                      v-if="sublistTextAreas.includes(value)"
                      class="form-control"
                      :disabled="actionType === 'read'"
                      :maxlength="maxLength[key]"
                      placeholder="Отсутствует"
                      v-model.trim="form[key]"
                    />
                    <input
                      v-else
                      class="form-control"
                      placeholder="Отсутствует"
                      :name="key"
                      :maxlength="maxLength[key]"
                      :disabled="actionType === 'read'"
                      v-model.trim="form[key]"
                    />
                  </fieldset>
                </div>
              </div>
            </div>
            </template>
          </Sublist>
        </Tab>
      </Tabs>
    </template>
  </Form>
</template>

<script>
import { validationMixin } from "vuelidate";
import schemas from "@/stock/validation-schemas";
import { stockComponentService } from "@/stock/api-services";

import EntityReferencesModal from "@/_shared/components/modals/EntityReferencesModal";
import ForeignKeyInput from "@/_shared/components/ui/ForeignKeyInput";
import ReferencesList from "@/_shared/components/ui/ReferencesList";
import DropdownMenu from "@/_shared/components/ui/DropdownMenu";
import Tabs from "@/_shared/components/ui/Tabs";
import Tab from "@/_shared/components/ui/Tab";

import Sublist from "@/_shared/features/form/Sublist";
import ImageInput from "@/_shared/features/form/ImageInput";
import Form from "@/_shared/widgets/Form";

import { useForm, useNotification, useImageField } from "@/_shared/mixins";
import { formsFields } from "@/stock/constants";

import { objectHelper } from "@/_shared/utils";
const { createCopy, createFromKeys } = objectHelper;
export default {
  mixins: [
    validationMixin,
    useForm,
    useNotification,
    useImageField,
  ],
  components: {
    ImageInput,
    ForeignKeyInput,
    ReferencesList,
    EntityReferencesModal,
    Form,
    DropdownMenu,
    Sublist,
    Tabs,
    Tab,
  },
  data() {
    return {
      openedModals: {
        package_item: false,
        parent: false,
        cut_of_clothes: false,
        cloths_data: false,
        sewing_accessories_data: false,
        packages_data: false,
        promotional_products_data: false,
        sizes_data: false,
      },
      sublistTextAreas: [
        "Текстовое описание",
        "Состав ткани",
        "Состав подкладки",
        "Инструкция по уходу",
        "Художественное описание",
        "Детали",
      ],
      selectValues: ["муж.", "жен.", "унисекс"],
      fallbackLink: "/products",
      entityName: {
        readonly: "Продукт",
        modify: "продукта",
      },
      form: createFromKeys(formsFields.product.labels),
    };
  },
  validations() {
    return {
      form: this.validationSchema,
    };
  },
  async created() {
    const joins = ["packages", "products", "cut_of_clothes"];
    const callback = stockComponentService.get("products", joins);
    const addingFields = createCopy(this.form);
    await this.setFormFields(addingFields, callback).then(() => {
      this.checkPreviewImageExistence();
      if (!this.form.gender) {
        this.form.gender = "муж.";
      }
      this.form.sizes_data = JSON.parse(this.form.sizes_data);
    });
  },
  computed: {
    tabsHeaderStyles() {
      return {
        'margin-left': '16px',
        'margin-bottom': '16px',
      };
    },
    validationSchema() {
      return schemas.product;
    },
    maxLength() {
      return formsFields.product.maxlength;
    },
    foreignKeyLabels() {
      const { package_item, parent, cut_of_clothes } =
        formsFields.product.labels;
      return { package_item, parent, cut_of_clothes };
    },
    materialListLabels() {
      const {
        cloths_data,
        sewing_accessories_data,
        packages_data,
        promotional_products_data,
      } = formsFields.product.labels;
      return {
        cloths_data,
        sewing_accessories_data,
        packages_data,
        promotional_products_data,
      };
    },
    modalLabels() {
      const { sizes_data } = formsFields.product.labels;
      return {
        ...this.foreignKeyLabels,
        ...this.materialListLabels,
        sizes_data,
      };
    },
    mainLabels() {
      const {
        name, type, barcode, subtype, gender,
        price, vendor_code,
      } = formsFields.product.labels;
      return {
        name,
        type,
        barcode,
        vendor_code,
        price,
        gender,
        subtype,
      };
    },
    mainCharacterLabels() {
      const {
        color,
        filler_material,
        text_description,
        cloth_structure,
        lining_structure,
        care_advices,
        artistic_description,
      } = formsFields.product.labels;
      return {
        color,
        filler_material,
        text_description,
        cloth_structure,
        lining_structure,
        care_advices,
        artistic_description,
      };
    },
    additionalCharacterLabels() {
      const {
        NDS,
        season,
        collection,
        style,
        amount_in_package,
        collar_form,
        waist,
        clothing_type,
        details,
      } = formsFields.product.labels;
      return {
        NDS,
        season,
        collection,
        style,
        amount_in_package,
        collar_form,
        waist,
        clothing_type,
        details,
      };
    },
  },
  methods: {
    async remove() {
      return await stockComponentService.remove([this.form.id], 'product');
    },
    getAdditionalFilters(fieldKey) {
      if (fieldKey === 'sizes_data' && this.form.gender !== 'унисекс') {
        const filters = [{
          field: 'gender',
          predicate: 'eq',
          value: this.form.gender,
        }];
        return filters;
      }
    },
    getModalFields(fieldKey) {
      const fields = {
        'sizes_data': {
          'gender': 'Пол',
          'international_version': 'Межд. размеры',
          'russian_version': 'Рос.размеры',
        },
      };
      if (fields[fieldKey]) {
        return fields[fieldKey];
      }
    },
    getRecordLink(fieldKey) {
      if (this.form[fieldKey]) {
        const slug = this.getLinkSlug(fieldKey);
        const { id } = this.form[fieldKey];
        const results = `/${slug}/${id}`;
        return results;
      }
    },
    getLinkSlug(key) {
      const slugs = {
        package_item: 'packages',
        parent: 'products',
        cut_of_clothes: 'cut_of_clothes',
        cloths_data: 'cloths',
        sewing_accessories_data: 'sewing_accessories',
        packages_data: 'packages',
        promotional_products_data: 'promotional_products',
        sizes_data: 'sizes',
      };
      const currentSlug = slugs[key];
      return currentSlug;
    },
    updateListField(key, values = null) {
      const isSingleObject = !Array.isArray(values);
      if (isSingleObject) {
        return this.form[key] = { ...values, count: 1 };
      }
      if (key !== 'sizes_data') {
        values.forEach((value) => value.count = 1);
      }
      if (this.form[key].length < 1) {
        return (this.form[key] = values);
      }
      this.form[key] = [...this.form[key], ...values];
    },
    allowedOneChoiceInModal(value = "") {
      return !!Object.values(this.foreignKeyLabels).includes(value);
    },
    getSublistSubtitle(labels = {}) {
      return labels.NDS ? "Дополнительные" : "Основные";
    },
    async submit() {
      const callback = async () => {
        return await this.encodeImage()
          .then(async () => {
            return await stockComponentService[this.actionType](
              this.form, "product", this.image,
            );
          })
          .catch((error) => {
            throw new Error(error.message);
          });
      };
      await this.sendForm(callback);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/pages/ProductForm.vue